const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    gap: "30px",
    alignSelf: "stretch",
    backgroundColor: "transparent",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "20px",
  },
  addButton: {
    backgroundColor: "#5958e1",
    "&:hover": {
      backgroundColor: "#5958c0",
    },
  },
  activityRow: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "16px",
    borderRadius: "14px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: "white",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  activityHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  iconButton: {
    color: "#5958e1",
    marginRight: "16px",
  },
  icon: {
    marginRight: "8px",
    color: "#5958e1",
  },
  title: {
    fontWeight: "bold",
    marginRight: "16px",
    flex: 1,
  },
  date: {
    color: "text.secondary",
  },
  notesContainer: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  notes: {
    fontStyle: "italic",
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "8px",
  },
  actionChip: {
    backgroundColor: "#f0f0f0",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
};

export default styles;